import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  Link,
  Typography
} from '@mui/material'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export const ControlledFileInput = ({
  name,
  defaultValue = '',
  label,
  buttonLabel = 'Upload File',
  helperText,
  accept = 'application/pdf',
  initial
}) => {
  const { control, formState } = useFormContext()
  const [file, setFile] = useState(undefined)

  return (
    <>
      {label && (
        <Typography variant='body1' style={{ paddingBottom: 8 }}>
          {label}
        </Typography>
      )}
      <Grid container spacing={2} flexWrap='nowrap'>
        <Grid item flexShrink={0}>
          <FormControl fullWidth style={{ maxWidth: 150 }}>
            <Controller
              name={name}
              control={control}
              defaultValue={defaultValue}
              render={({ field: { onChange } }) => {
                const handleChange = e => {
                  setFile(e.target?.files?.[0].name)
                  onChange(e.target?.files)
                }
                return (
                  <Button
                    variant='contained'
                    component='label'
                    disableElevation
                  >
                    {buttonLabel}
                    <input
                      type='file'
                      hidden
                      onChange={handleChange}
                      accept={accept}
                    />
                  </Button>
                )
              }}
            />
            {helperText !== undefined &&
              formState.errors[name] === undefined && (
                <FormHelperText id={`helper-text-${name}`}>
                  {helperText}
                </FormHelperText>
              )}
            {formState.errors[name]?.message !== undefined && (
              <FormHelperText
                id={`error-helper-text-${name}`}
                error
                style={{ textAlign: 'right', paddingRight: 8 }}
              >
                {formState.errors[name]?.message}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        {file !== undefined ? (
          <Grid item container alignItems='center'>
            <Typography variant='body1'>{file}</Typography>
          </Grid>
        ) : (
          initial && (
            <Grid item container alignItems='center'>
              <Box width='100%' overflow='hidden'>
                <Link
                  target='_blank'
                  rel='noreferrer'
                  href={initial?.webViewLink}
                >
                  {initial.name}
                </Link>
              </Box>
            </Grid>
          )
        )}
      </Grid>
    </>
  )
}
